import * as React from "react";
import { useHistory } from "react-router";
import { Icon } from "@fluentui/react/lib/Icon";

import { ROUTE } from "../../../../../shared/constants/routes";
import { ICON } from "../../../../../shared/constants/icons";
import { TEXT } from "../../../../../shared/constants/texts";

const SubHeader: React.FC = () => {
  const history = useHistory();

  const navigateToAddToIci = () => {
    history.push(ROUTE.ADD_TO_ICI);
  };

  const onEnterPressLeftIcon = (e) => {
    if (e.key === TEXT.ENTER || e.keyCode === TEXT.ENTER_KEY_CODE) {
      navigateToAddToIci();
    }
  };

  return (
    <div className="sub-header-single-email-upload">
      <div className="icon-navigate" onClick={navigateToAddToIci} tabIndex={1} onKeyDown={onEnterPressLeftIcon}>
        <Icon iconName={ICON.LEFT} />
        <span className="sr-only">{TEXT.LEFT}</span>
      </div>
      <p>{TEXT.ADD_EMAIL}</p>
    </div>
  );
};

export default SubHeader;
